import { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, Alert, KeyboardAvoidingView, Platform, ScrollView } from 'react-native';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { useAuth } from '@/hooks/useAuth';
import { useWorkoutPlans } from '@/hooks/useWorkoutPlans';

export default function NewPlanScreen() {
  const { studentId, routineId } = useLocalSearchParams<{ studentId: string; routineId?: string }>();
  const { profile } = useAuth();
  const { createPlan } = useWorkoutPlans({});
  const router = useRouter();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleCreate() {
    if (!name.trim()) { Alert.alert('Dê um nome para a ficha'); return; }
    setLoading(true);
    try {
      const plan = await createPlan({
        name: name.trim(),
        student_id: studentId,
        personal_id: profile!.id,
        ...(routineId ? { routine_id: routineId } : {}),
      });
      router.replace(`/(personal)/plans/${plan.id}` as any);
    } catch (e: any) {
      Alert.alert('Erro', e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <KeyboardAvoidingView style={styles.container} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
      <ScrollView contentContainerStyle={styles.scroll} keyboardShouldPersistTaps="handled">
        <Text style={styles.label}>Nome da ficha</Text>
        <TextInput style={styles.input} value={name} onChangeText={setName} placeholder="Ex: Treino A — Peito e Tríceps" />
        <TouchableOpacity style={styles.button} onPress={handleCreate} disabled={loading}>
          <Text style={styles.buttonText}>{loading ? 'Criando...' : 'Criar Ficha'}</Text>
        </TouchableOpacity>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  scroll: { padding: 20 },
  label: { fontSize: 13, fontWeight: '600', color: '#555', marginBottom: 8 },
  input: { borderWidth: 1, borderColor: '#ddd', borderRadius: 8, padding: 12, fontSize: 15, color: '#1A1A1A' },
  button: { backgroundColor: '#C8102E', padding: 16, borderRadius: 8, alignItems: 'center', marginTop: 24 },
  buttonText: { color: '#fff', fontWeight: 'bold', fontSize: 16 },
});
